import { ElementRef, Injectable, Input } from '@angular/core';
import {fromEvent as observableFromEvent, Observable , Subject } from 'rxjs';

declare var $:any;

@Injectable()
export class CmnUiService {
    
    /**Subscribe to this subject to know when the caps lock key state has changed.*/
    public capsLockStateChanged : Subject<boolean> = new Subject<boolean>();
  
    @Input() useCapsLockWarning: boolean = false;
  
    constructor(){
      observableFromEvent(window, 'keydown')
        .subscribe((event) => {
            let typeCastedEvent: any = event;
            this.onKeydown(event);
        });
    }
  
    onKeydown(event) {
        if(event.getModifierState && event.getModifierState("CapsLock")){
          this.capsLockStateChanged.next(true); 
        } else {
          this.capsLockStateChanged.next(false);
        }
    }
 
    placeSvgCode = function(sectionToReplaceImgs?: string) {
         
        if (sectionToReplaceImgs === undefined || sectionToReplaceImgs === null) {
            var sectionToReplaceImgs: string = "";
        }
        
        //$(".navbar-collapse").css({"background-color": "#000066"}); // TEST, CAN DELETE
        
        $(sectionToReplaceImgs + ' img').each(function() {
            var $img = $(this);
            var imgURL = $img.attr('src');
            
            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');
                
                var attributes = $img.prop('attributes');
                $.each(attributes, function(i) {
                    if (this.name != 'src' ) {
                        if(this.name != 'svg-title') {
                          $svg.attr(this.name, this.value);
                        } else {
                        	$svg.attr('aria-label', this.value);
						}
                    }
                });
                
                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');
                
                if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr("viewBox 0 0  ${$svg.attr('height')} ${$svg.attr('width')}");
                }
            
                // Replace image with new SVG
                $img.replaceWith($svg);
            
            }, 'xml');
            
        });
    };
    
    btnStates = function() {
        var btns = '.btn, .ui-link, .btnHelp > a, a.btnHelp';
        var timer = 250;

        var delay = (function() {
            var delayTimer = 0;
            return function(callback, ms) {
                clearTimeout(delayTimer);
            };
        })();

        if ('ontouchstart' in document.documentElement) {
            $(document).on({
                touchstart: function(e) {
                    $(btns).not(this).removeClass("ui-focus");
                    $(e.target).closest(btns).addClass("ui-focus");
                },
                touchend: function(e) {
                    delay(function() {
                        $(e.target).closest(btns).removeClass("ui-focus ui-btn-active");
                    }, timer);
                }
            }, btns).on({
                click: function(e) {
                    if (!$(e.target).closest(btns)) {
                        $(btns).removeClass("ui-focus");
                    }
                }
            });
        } else {
            $(document).on({
                mouseover: function(e) {
                    $(e.target).closest(btns).addClass("hover");
                },
                mouseout: function(e) {
                    $(e.target).closest(btns).removeClass("hover ui-focus");
                },
                click: function(e) {
                    $(btns).not(this).closest(btns).removeClass("ui-focus");
                    setTimeout(function() {
                        $(e.target).closest(btns).removeClass("ui-btn-active");
                    }, timer);
                },
                focus: function(e) {
                    $(e.target).closest(btns).addClass("ui-focus");
                },
                blur: function(e) {
                    $(e.target).closest(btns).removeClass("ui-focus");
                }
            }, btns).on({
                click: function(e) {
                    if (!$(e.target).closest(btns)) {
                        $(btns).removeClass("ui-focus");
                    }
                }
            });
        }
    }
    
    debounce = function(callback, interval) {
        var timeout = null;
        return function() {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                callback.apply(this); 
            }, interval);
        };
    }
    
    scrollAnimate = function(args) {
        
        var defaultArgs = {
            scrollElement: "form",
            scrollPosition: "0",
            scrollFocus: null,
            timer2: 250
        }
        
        args = $.extend({}, defaultArgs, args);
        
        //document.getElementById(args.scrollElement).scrollIntoView();
        $(args.scrollElement).animate({scrollTop: args.scrollPosition}, args.timer2);
        
        if (args.scrollFocus != null) {
            $(args.scrollFocus).focus();
        }
        
    }
    
    skipLink = function() {
        let skipHere: any;
        if (document.getElementById('skipLinkTarget') != null || undefined) {
            skipHere = document.getElementById("skipLinkTarget");
        } else if (document.querySelector('cmn-page-title > h1')) {
            skipHere = document.querySelector('cmn-page-title > h1');
        } else {
            skipHere = document.querySelector(".content h1:nth-of-type(1)");
            skipHere.setAttribute("tabindex", "0");
        }
        
        var scrollHere: number = skipHere.getBoundingClientRect().top - 10;
        
        this.scrollAnimate({
            scrollPosition: scrollHere,
            scrollFocus: skipHere
        });
       
    }
    
    /*
     * The following method accepts and event object and uses it to grab the value of the targeted input field.
     * It then runs string replace on the value to replace left and right single and double quotes with regular
     * UTF single and double quotes. The left and right single and double quotes can be introduced by iOS when the
     * user tries to enter a quote. iOS has a feature called smart punctuation that replaces quotes with the left
     * and right versions.
     */
    preventSmartPunctuation(fieldValue: string): string {
        try {
            let originalInputValue = fieldValue;
            let cleanedInputValue = originalInputValue.replace(/[\u2018\u2019\u201C\u201D]/g, (c) => '\'\'""'.substr('\u2018\u2019\u201C\u201D'.indexOf(c), 1));
            
            if (originalInputValue !== cleanedInputValue) {
              return cleanedInputValue;
            } else {
              return originalInputValue;
            }            
        }
        catch (err) {
            // do nothing
        } 
    }
};
